import { style } from '@vanilla-extract/css';

/*
  The dropdown itself carries no padding: each filter panel pads its own content
  so the apply bar can sit flush against the bottom border.
*/
export const activeFilterContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
});
